/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Credentials_Status_Missing_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add an API key to enable this integration for your organization." |
*
* @param {Integrations_Credentials_Status_Missing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_status_missing_description = /** @type {((inputs?: Integrations_Credentials_Status_Missing_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Status_Missing_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hinterlegen Sie einen API-Schlüssel, um diese Integration für Ihre Organisation freizuschalten.")
	return /** @type {LocalizedString} */ ("Add an API key to enable this integration for your organization.")
});